import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const scrollToHashTarget = (hash: string) => {
  const targetId = decodeURIComponent(hash.slice(1));

  if (!targetId) {
    return false;
  }

  const targetById = document.getElementById(targetId);
  if (targetById) {
    targetById.scrollIntoView();
    return true;
  }

  const targetByName = document.getElementsByName(targetId)[0];
  if (targetByName instanceof HTMLElement) {
    targetByName.scrollIntoView();
    return true;
  }

  return false;
};

export const ScrollManager = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    if (location.hash && scrollToHashTarget(location.hash)) {
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.hash, location.pathname]);

  return null;
};
